import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-select-filter',
  templateUrl: './custom-select-filter.component.html',
  styleUrls: ['./custom-select-filter.component.scss'],
  standalone: true,
  imports: [TableModule, SelectModule, ReactiveFormsModule,]
})
export class CustomSelectFilterComponent {
  @Input() field!: string;
  @Input() itemsSelect: { label: string; value: any }[] = [];
  @Input() control!: FormControl;

  @Output() onChangeSelectFilter = new EventEmitter<{ propertyName: string, valueFilter: any }>();

  filterInput(event: any) {
    this.onChangeSelectFilter.emit({ propertyName: this.field, valueFilter: event });
  }

}
